<template>
    <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="grid-stack-item">
            <div class="header">
                <h1>{{ $t('Edit Email Template') }}</h1>
            </div>
            <div class="my-content">
                <div class="grid-stack-item-content">
                    <el-form :label-position="labelPosition" :model="emailTemplateForm.data" ref="emailTemplateForm">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-card shadow="never">
                                    <el-tabs type="card" v-model="activeName" class="menu-tab">
                                        <el-tab-pane v-for="(item) in languages" :label="item.Text" :name="item.lang" v-bind:key="item.lang">
                                            <el-form-item :label="$t('Title')" prop="title" v-for="(lang, index) in emailTemplateForm.data.languages" v-bind:key="'title' + index" v-if="item.lang == lang.slug">
                                                <el-input v-model="emailTemplateForm.data.languages[index].pivot.title"></el-input>
                                            </el-form-item>
                                            <el-form-item :label="$t('Subject')" prop="subject" v-for="(lang, index) in emailTemplateForm.data.languages" v-bind:key="'subject' + index" v-if="item.lang == lang.slug">
                                                <el-input v-model="emailTemplateForm.data.languages[index].pivot.subject"></el-input>
                                            </el-form-item>
                                            <el-form-item :label="$t('Mail Content')" prop="message" v-for="(lang, index) in emailTemplateForm.data.languages" v-bind:key="'message' + index" v-if="item.lang == lang.slug">
                                                <el-input type="textarea" :rows="10" placeholder="Please input" v-model="emailTemplateForm.data.languages[index].pivot.message">
                                                </el-input>
                                            </el-form-item>
                                        </el-tab-pane>
                                    </el-tabs>
                                </el-card>
                                <el-form-item :label="$t('Status')">
                                    <el-switch v-model="emailTemplateForm.data.status" active-color="#13ce66" inactive-color="#ff4949" active-value="active" inactive-value="inactive">
                                    </el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item class="no-margin">
                                    <el-button type="primary" @click="submitForm('emailTemplateForm')">{{ $t('Save') }}</el-button>
                                    <router-link tag="el-button" to="/email-templates" class="el-button--cancel">{{
                                        $t('Cancel')
                                        }}</router-link>
                                    <el-button type="info" @click="dialogPreviewVisible = true">{{ $t('Preview') }}</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </el-col>
        <el-dialog v-if="emailTemplateForm.data.languages[activeName]" :title="emailTemplateForm.data.languages[activeName].pivot.subject" :visible.sync="dialogPreviewVisible">
            <div v-html="emailTemplateForm.data.languages[activeName].pivot.message"></div>
        </el-dialog>
    </el-row>
</template>
<script>
    export default {
        data() {
            return {
                activeName: "en",
                labelPosition: "top",
                languages: process.env.KIPAKI_languages,
                emailTemplateForm: {
                    data: {
                        languages: []
                    }
                },
                dialogPreviewVisible: false
            };
        },
        mounted() {
            request({
                    url: "email-templates/" + this.$route.params.slug,
                    method: "get"
                })
                .then(response => {
                    this.emailTemplateForm = response.data;
                })
                .catch(error => {});
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "email-templates/" + this.$route.params.slug,
                                method: "patch",
                                data: this.emailTemplateForm.data
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/EmailTemplates/EditEmailTemplate.vue